import React from 'react';

export const DEFAULT_BOARD_COLOR_OPTIONS = [
  { id: 'primary', className: 'bg-primary' },
  { id: 'main-d', className: 'bg-main-d' },
  { id: 'secondary', className: 'bg-secondary' },
  { id: 'contrast', className: 'bg-contrast' },
  { id: 'red', className: 'bg-red' },
  { id: 'orange', className: 'bg-orange' },
  { id: 'yellow', className: 'bg-yellow' },
  { id: 'lime', className: 'bg-lime' },
  { id: 'green', className: 'bg-green' },
  { id: 'blue', className: 'bg-blue' },
  { id: 'purple', className: 'bg-purple' },
  { id: 'pink', className: 'bg-pink' },
];

export const BoardToolboxColorPalette = ({
  options = DEFAULT_BOARD_COLOR_OPTIONS,
  value = '',
  onChange,
  titlePrefix = 'Couleur',
  className = '',
}) => (
  <div className={`flex items-center gap-05 ${className}`.trim()}>
    {options.map(option => (
      <button
        key={option.id}
        type='button'
        className={`w-09 h-09 rounded-full transition ${option.className} ${
          value === option.id
            ? 'ring-1 ring-contrast ring-offset-1 ring-offset-main opacity-100'
            : 'opacity-80 hover:opacity-100'
        }`}
        onClick={() => onChange?.(option.id)}
        title={`${titlePrefix}: ${option.id}`}
      />
    ))}
  </div>
);
